export class SiteBanner {
    bannerId: number;
    bannerHeader: string;
    bannerText: string;
    bannerType: string;
    isDisplayed: boolean;
    lastUpdatedBy: string;
    lastUpdatedDate: Date;

    constructor() {
        this.isDisplayed = false;
    }
}

